import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Index from './pages/Index';
import Appendix from './pages/Appendix';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/appendix" element={<Appendix />} />
      </Routes>
    </Router>
  );
}

export default App;